(() => {
  const bars = document.querySelectorAll('[data-ef-mobile-buy]');
  if (!bars.length) return;

  bars.forEach((bar) => {
    const proxy = bar.querySelector('[data-ef-submit-proxy]');
    if (!proxy) return;
    proxy.addEventListener('click', () => {
      const section = bar.closest('.section-main-product');
      const submit = section && section.querySelector('.product-info-buy-buttons .add-cart-button:not([disabled])');
      if (submit) submit.click();
    });

    if (globalThis.webvista && globalThis.PUB_SUB_EVENTS) {
      webvista.subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event.data || event.data.sectionId !== bar.dataset.sectionId || !event.data.html) return;
        const sourceBar = event.data.html.querySelector('[data-ef-mobile-buy]');
        if (!sourceBar) return;
        const sourcePrice = sourceBar.querySelector('strong');
        const price = bar.querySelector('strong');
        if (sourcePrice && price) price.textContent = sourcePrice.textContent;
        const sourceButton = sourceBar.querySelector('[data-ef-submit-proxy]');
        if (sourceButton) proxy.disabled = sourceButton.disabled;
        proxy.textContent = proxy.disabled ? 'Sold out' : 'Add to cart';
      });
    }
  });

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-ef-mobile-buy] [data-ef-submit-proxy]').forEach((proxy) => {
      proxy.disabled = !document.querySelector('.product-info-buy-buttons .add-cart-button:not([disabled])');
    });
  });
})();
